import * as React from 'react'
import { Provider as StoreProvider, useSelector } from 'react-redux'
import { Router } from 'react-router'
import { Store } from 'redux'
import { History } from 'history'
import { ThemeProvider } from 'emotion-theming'

import { Global } from '@emotion/core'

import Root from './components/layout/Root'
import Header from './components/layout/Header'
import normalize from './styles/normalize'
import globals from './styles/globals'
import { ApplicationState } from './store'
import { Loading } from './components/data/Loading'
import MobileBottomBar from './components/layout/MobileBottomBar'
import Routes from './routes'
import LayoutContainer from './containers/LayoutContainer'
import * as themes from './styles/theme'
import styled from './utils/styled'
import { getSalonGuidFromUrlParams } from './utils/urlParams'

const MainContainer = styled.div`
  padding-bottom: 4.125rem;

  @media (min-width: ${props => props.theme.breakpoints.sm}) {
    padding-bottom: 0rem;
  }
`

interface MainProps {
  store: Store<ApplicationState>
  history: History
}

const Main: React.FC<MainProps> = ({ store, history }) => {
  return (
    <StoreProvider store={store}>
      <Router history={history}>
        <LayoutContainer>
          {({ theme }) => (
            <ThemeProvider theme={themes[theme]}>
              <Root>
                <Global styles={normalize} />
                <Global styles={globals} />
                <MainContent />
              </Root>
            </ThemeProvider>
          )}
        </LayoutContainer>
        {/* {isTokenFound && <p>isTokenFound</p>}
        {!isTokenFound && <p>NOT isTokenFound</p>} */}
      </Router>
    </StoreProvider>
  )
}

const MainContent: React.FC = () => {
  const { loading } = useSelector((state: ApplicationState) => state.salon)
  const salonGuidFromUrl = getSalonGuidFromUrlParams()

  return (
    <>
      {loading && <Loading />}
      <Header />
      <MainContainer>
        <Routes />
      </MainContainer>
      {salonGuidFromUrl && <MobileBottomBar />}
    </>
  )
}

export default Main
